import { Select } from '@octano/global-ui';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useValidations } from '../../../../hooks/useValidations';
import { ScheduleSectionFormData } from '../../../SectionsMaintainer/parts/ModalMaintainerSchedulePre';
import { useNonStructuredSectionClassroomLoader } from '../hooks/NonStructuredSectionClassroomLoader';
import { NonStructuredSectionClassroomLoaderFilters } from '../types';

const prefix = 'sectionsMaintainer.update';

interface Props {
  sectionId: number | string;
  filters?: NonStructuredSectionClassroomLoaderFilters;
}

function MaintainerScheduleClassroomSelector({ sectionId, filters }: Props) {
  const { control } = useFormContext<ScheduleSectionFormData>();
  const { result, updateQuery } = useNonStructuredSectionClassroomLoader();
  const { msgValidations } = useValidations();

  const data = useMemo(() => {
    if (!result?.success) {
      return [];
    }
    return result?.data ?? [];
  }, [result]);

  const { t } = useTranslation();

  useEffect(() => {
    if (filters) {
      updateQuery({ sectionId, ...filters });
    }
  }, [filters, sectionId, updateQuery]);

  return (
    <Select
      label={t(`${prefix}.classroom`)}
      name="classroom"
      options={data!.map((classroom) => ({
        value: classroom.id,
        label: classroom.name,
      }))}
      control={control}
      rules={{ required: msgValidations.required }}
      shouldUnregister
    />
  );
}

export default MaintainerScheduleClassroomSelector;
